<template>
  <div class="out-wrap" v-if="!isNewEdition">
    <!-- 敏感词设置 -->
    <el-container class="sen-setting-container" >
      <!-- 侧边栏 -->
      <el-aside width="280px" style="padding:0 10px 0 0;">
        <el-tree
          ref="SlotTree"
          :data="setTree"
          :current-node-key="currenId"
          :default-expanded-keys="[currenId]"
          :default-checked-keys="[currenId]"
          :props="defaultProps"
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="nodeClick"
          node-key="wordTypeId"
        >
          <div class="comp-tr-node" slot-scope="{ node, data }">
            <template>
              <div class="template">
                <!-- 名称： 新增节点增加class -->
                <div class="comp-tr-node--name">
                  {{ node.label }}
                </div>
                <!-- 按钮 -->
                <div class="comp-tr-node--btns">
                  <!-- 新增 -->
                  <el-button
                    v-if="node.level == 1 && senGroupOption"
                    icon="el-icon-plus"
                    size="mini"
                    circle
                    type="primary"
                    @click.stop="handleAdd(node, data)"
                  ></el-button>
                  <!-- 编辑 -->
                  <el-button
                    v-if="node.level != 1 && senGroupOption"
                    icon="el-icon-edit"
                    size="mini"
                    circle
                    type="info"
                    @click.stop="handleEdit(node, data)"
                  ></el-button>
                  <!-- 删除 -->
                  <el-button
                    v-if="node.level != 1 && senGroupOption"
                    icon="el-icon-delete"
                    size="mini"
                    circle
                    type="danger"
                    @click.stop="handleDel(node, data)"
                  ></el-button>
                </div>
              </div>
            </template>
          </div>
        </el-tree>
      </el-aside>
      <div style="border-right: 1px solid #EBEEF5;"></div>
      <el-main class="main-container">
        <!-- 内容区 -->
        <div style="width: 100%;height: 100%;">
          <!-- 头部 -->
          <div class="main-head">
            <el-row>
              <!-- 新增敏感词按钮 -->
              <el-col :span="3">
                <el-button
                  size="mini"
                  type="primary"
                  v-if="senOption"
                  @click="addNewSen"
                  >添加敏感词</el-button
                >
              </el-col>
              <!-- 敏感词搜索框 -->
              <el-col :span="3" style="float:right;margin-bottom:5px">
                <el-input
                  size="mini"
                  suffix-icon="el-icon-search"
                  v-model="getSensiListParams.wordName"
                  placeholder="敏感词"
                  @blur="onInputBlur"
                  @clear="onInputBlur"
                  clearable
                >
                </el-input>
              </el-col>
            </el-row>
          </div>
          <!-- 表格区 -->
          <el-row>
            <el-col>
              <el-table
                size="small"
                :data="tableData"
                fit
                @row-click="handleclick"
                highlight-current-row
                align="center"
                :header-cell-style="{ background: '#F9F9F9' }"
                height="calc(100vh - 242px)"
                ref="cusChatTable"
                style="font-size: 13px"
              >
                <el-table-column
                  prop="wordName"
                  label="敏感词"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="createBy"
                  label="操作人"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="操作时间"
                  min-width="150"
                ></el-table-column>
                <el-table-column label="操作" min-width="100" v-if="senOption">
                  <template slot-scope="scope">
                    <!-- <el-button
                      v-if="true"
                      class="table-button"
                      type="text"
                      size="small"
                      @click.native="handleShowSen(scope.$index, scope.row)"
                      >查看</el-button
                    > -->
                    <el-button
                      v-if="true"
                      class="table-button"
                      type="text"
                      size="small"
                      @click.native="handleSenDel(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <Pagination
            :childMsg="pageparm"
            :pageSizes="pageSizes"
            @callBack="callBack"
          ></Pagination>
        </div>
      </el-main>
    </el-container>
    <OptionSenWordType
      ref="OptionSenWordType"
      @createSuccess="createSuccess"
    ></OptionSenWordType>
    <addSensitive ref="addSensitive" @addSuccess="addSuccess"></addSensitive>
  </div>
</template>

<script>
import {
  addSensitiveWordType, // 新建分类
  getSensitiveWordTypeList, // 获取分类列表
  delSensitiveWordType, // 删除分类
  updateSensitiveWordType, // 编辑分类
  getSensitiveWordOneTypeList, // 获取单个分类
  addSensitiveWord, // 添加敏感词
  delSensitiveWord, // 删除敏感词
  getSensitiveWordList, // 获取敏感词列表
} from "@/api/senWord/senWord.js";
import OptionSenWordType from "./components/SenWordSettings/optionSensitiveWordTypeDialog";
import addSensitive from "./components/SenWordSettings/addSensitive";
import { getSessionVersion } from "@/api/staff/staff.js";
export default {
  name: "component-tree",
  components: {
    OptionSenWordType,
    addSensitive,
  },
  data() {
    return {
      currenId: "startId",
      setTree: [], // tree数据
      defaultProps: {
        // 默认设置
        id: "wordTypeId",
        children: "children",
        label: "wordTypeName",
      },
      // 获取敏感词列表参数
      getSensiListParams: {
        pageNum: 1,
        pageSize: 20,
        wordTypeId: "",
        wordName: "",
      },
      // 敏感词表格数据
      tableData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      wordNames: [], // 所有敏感词
      senGroupOption: true, // 可新增、编辑、删除分组
      senOption: true, // 可新增、删除敏感词
      // 是否新版会话存档
      isNewEdition: false,
    };
  },
 async created() {
      /** 获取进入系统后获取到的新旧版进行判断， */
   await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.isNewEdition = res.data
            console.log("dsfsdfsfsdf1111",this.isNewEdition);
            window.localStorage.setItem("isNewEdition", this.isNewEdition);
          } else {
            // this.$message.error("获取版本参数失败")
          }
        }).catch((err) => {
          // this.$message.error("获取版本参数失败")
          console.log("新旧版本参数获取失败", err);
        });

    // console.log("dfdsfsfsd",window.localStorage.getItem("isNewEdition"));
    // this.isNewEdition = window.localStorage.getItem("isNewEdition");
    /** 因为新版没有这几个功能，后端说路由是写死数据库的，不好去掉，也不想加接口，就给增加工作量 */
    if (this.isNewEdition) {
      this.$confirm("功能正在开发中，敬请期待", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          /** 关闭当前路由 */
          this.$store.dispatch('tagsView/delView', this.$route)
          /** 跳转index页面 */
          this.$router.push({ path: "/index" });
        })
        .catch(() => {});
        return
    }
    // 初始值
    this.getSensiListParams.pageNum = this.pageparm.currentPage;
    this.getSensiListParams.pageSize = this.pageparm.pageSize;
    this.getSensitiveWordTypeList();
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX", newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "敏感词设置") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("kxzbjscfz") != -1) {
                // 可新增、编辑、删除分组
                this.senGroupOption = true;
              } else {
                this.senGroupOption = false;
              }
              if (senBtnAuthority.indexOf("kxzscmgc") != -1) {
                // 可新增、删除敏感词
                this.senOption = true;
              } else {
                this.senOption = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    // 分类点击事件
    nodeClick(_data, _node, self) {
      this.currenId = _data.wordTypeId;
      let obj = {
        wordTypeId: _data.wordTypeId,
        wordName: "",
        pageNum: 1,
        pageSize: 20,
      };
      this.getSensiListParams = JSON.parse(JSON.stringify(obj));
      this.getSensitiveWordList(this.getSensiListParams);
    },
    // 编辑分类
    handleEdit(_node, _data) {
      if (!this.senGroupOption) {
        this.$confirm("您暂无权限修改敏感词分组", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      } else {
        if (_node.level == 1) {
          this.$message.warning("一级分类不可编辑修改！");
        } else {
          this.currenId = _data.wordTypeId;
          let obj = {
            wordTypeId: _data.wordTypeId,
            wordName: "",
            pageNum: 1,
            pageSize: 20,
          };
          this.getSensiListParams = JSON.parse(JSON.stringify(obj));
          this.$refs.OptionSenWordType.open(_data);
        }
      }
    },
    // 新增分类
    handleAdd(_node, _data) {
      if (!this.senGroupOption) {
        this.$confirm("您暂无权限新增敏感词分组", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      } else {
        if (_node.level >= 2) {
          this.$message.warning("当前已达到最高层级，无法新增！");
        } else {
          this.currenId = _data.wordTypeId;
          let obj = {
            wordTypeId: _data.wordTypeId,
            wordName: "",
            pageNum: 1,
            pageSize: 20,
          };
          this.getSensiListParams = JSON.parse(JSON.stringify(obj));
          this.$refs.OptionSenWordType.open();
        }
      }
    },
    // 删除
    handleDel(_node, _data) {
      if (!this.senGroupOption) {
        this.$confirm("您暂无权限删除敏感词分组", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      } else {
        if (_node.level == 1) {
          this.$message.warning("一级分类不可删除！");
        } else {
          this.$confirm("您确定删除该分类？提交后将无法撤回", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            iconClass: "el-icon-warning",
            customClass: "delete-messege",
            center: true,
          })
            .then((res) => {
              this.delSensitiveWordType(_data.wordTypeId);
            })
            .catch((action) => {
              this.$message("取消删除");
            });
        }
      }
    },
    // 新增/编辑 分类成功回调
    createSuccess(val) {
      if (val == "成功") {
        this.getSensitiveWordTypeList();
      }
    },
    // 新增敏感词成功
    addSuccess(val) {
      if (val == "成功") {
        this.getSensitiveWordList(this.getSensiListParams);
      }
    },
    // 表格单击事件
    handleclick() {},
    // 分页回调函数
    callBack(parm) {
      this.getSensiListParams.pageNum = parm.currentPage;
      this.getSensiListParams.pageSize = parm.pageSize;
      this.getSensitiveWordList(this.getSensiListParams);
    },
    // 添加敏感词按钮触发事件
    addNewSen() {
      if (!this.senOption) {
        this.$confirm("您暂无权限添加敏感词", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      } else {
        this.$refs.addSensitive.open(this.currenId, this.setTree);
      }
    },
    // 敏感词删除事件
    handleSenDel(index, row) {
      if (!this.senOption) {
        this.$confirm("您暂无权限删除敏感词", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      } else {
        this.$confirm("您确定删除该敏感词吗？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            this.delSensitiveWord(row.ruleId);
          })
          .catch((action) => {
            this.$message("取消删除");
          });
      }
    },
    // 敏感词搜索框的blur事件
    onInputBlur() {
      this.getSensiListParams.pageNum = 1;
      this.getSensitiveWordList(this.getSensiListParams);
    },
    // 获取分类列表
    getSensitiveWordTypeList(val) {
      let that = this;
      getSensitiveWordTypeList(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            res.data.wordTypeId = "startId";
            that.setTree = [res.data];
            this.$nextTick(() => {
              this.$refs.SlotTree.setCurrentKey(that.currenId);
            });
            that.getSensitiveWordList(this.getSensiListParams);
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },

    // 删除分类
    delSensitiveWordType(params) {
      let that = this;
      delSensitiveWordType(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message.success("删除成功！");
            that.currenId = "startId";
            let obj = {
              wordTypeId: "startId",
              wordName: "",
              pageNum: 1,
              pageSize: 20,
            };
            that.getSensiListParams = JSON.parse(JSON.stringify(obj));
            that.getSensitiveWordTypeList();
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },
    // 删除敏感词
    delSensitiveWord(params) {
      let that = this;
      delSensitiveWord(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message.success("删除敏感词成功！");
            that.getSensitiveWordList(this.getSensiListParams);
          }
        })
        .catch((err) => {
          that.$message.error("删除敏感词失败，请重试！");
          console.log(err, "errr");
        });
    },
    // 获取敏感词列表
    getSensitiveWordList(params) {
      let that = this;
      if (params.wordTypeId == "startId") {
        params.wordTypeId = "";
      }
      getSensitiveWordList(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.tableData = res.data.ruleList;
            that.pageparm.total = res.data.total;
            that.wordNames = [];
            that.tableData.forEach((item) => {
              let obj = {
                wordName: item.wordName,
                ruleId: item.ruleId,
              };
              that.wordNames.push(obj);
            });
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* common */

// 显示按钮
.show-btns {
  opacity: 1;
}
/* common end */
.sen-setting-container {
  height: 100%;
  width: 100%;
  display: flex;
  object-fit: fill;
  /deep/.el-tree-node__content {
    height: auto;
  }
  .main-container {
    padding: 0 0 0 10px !important;
    .main-head {
      margin-bottom: 10px;
    }
  }
}
// 自定义节点
.comp-tr-node {
  // label
  flex: 1;
  display: flex;
  .template {
    display: flex;
    flex: 1;
    width: 0;
    align-items: center;
    justify-content: flex-start;
  }
  .comp-tr-node--name {
    flex: 1;
    font-size: 14px;
    padding: 8px 2px 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // button
  .comp-tr-node--btns {
    opacity: 0;
    transition: opacity 0.1s;
    display: flex;
    align-items: center;
    margin-right: 4px;
    justify-content: flex-start;
    .el-button {
      transform: scale(0.8); // 缩小按钮
      & + .el-button {
        margin-left: -1px;
      }
    }
  }
}
// 高亮显示按钮
.is-current {
  & > .el-tree-node__content {
    height: auto;
    .comp-tr-node--btns {
      @extend .show-btns;
    }
  }
}
// 悬浮显示按钮
.el-tree-node__content {
  height: auto;
  &:hover {
    .comp-tr-node--btns {
      @extend .show-btns;
    }
  }
}
.out-wrap {
  width: 100%;
  height: 100%;
}
// 删除信息
.delete-messege {
  .el-icon-warning {
    color: #1296db !important;
    font-size: 40px;
    transform: rotate(180deg);
  }
}
</style>
